'use client';

import useSWR from 'swr';
import { getMemberProfile } from 'app/apis/member';
import { CACHE_QUERY_KEY } from 'app/constants';
import { COOKIE_KEY_MAP, cookie } from '@shared/services';

async function profileFetcher() {
    const memberId = cookie.get(COOKIE_KEY_MAP.memberAccessToken) || '';

    if (!memberId) {
        return null;
    }

    return getMemberProfile();
}

const defaultProfileState = {
    id: '',
    username: '',
    email: '',
    updated_email: '',
    phone_number: '',
    role: '',
    avatar: {
        src: null,
    },
    third_party_auth_list: [],
};

export function useMember() {
    const {
        data: profile,
        mutate: mutateProfile,
        isLoading,
    } = useSWR(CACHE_QUERY_KEY.memberProfile, profileFetcher);

    const state = {
        profile: profile?.data || defaultProfileState,
        isLoading,
    };

    const actions = {
        mutateProfile,
    };

    return {
        state,
        actions,
    };
}

export type UseMemberReturn = ReturnType<typeof useMember>;
